import React from "react";
import QuizContent from "../shared/QuizContent";
import QuizTitle from "../shared/QuizTitle";
import QuizOptions from "../shared/QuizOptions";
import QuizOption from "../shared/QuizOption";
import BackgroundVideo from "../shared/BackgroundVideo";
import { getQuizOptions } from "../../utils/quizOptions";
import { WomanIcon, ManIcon, NonBinaryIcon } from "../shared/GenderIcons";
import { VIDEO_URLS } from "../../utils/videoConfig";

const Step0 = ({ onAnswer }) => {
  const quizOptions = getQuizOptions("welcome");

  const handleOptionClick = (value) => {
    onAnswer("welcome", value);
  };

  const renderIcon = (iconType) => {
    switch (iconType) {
      case "woman":
        return <WomanIcon />;
      case "man":
        return <ManIcon />;
      case "nonBinary":
        return <NonBinaryIcon />;
      default:
        return null;
    }
  };

  return (
    <QuizContent>
      <BackgroundVideo src={VIDEO_URLS.video0} />
      <QuizTitle>How do you identify?</QuizTitle>
      <QuizOptions className="step0-options">
        {quizOptions.map((option) => (
          <QuizOption
            key={option.value}
            value={option.value}
            name="welcome"
            onClick={handleOptionClick}
            hasIcon={option.hasIcon}
            className="step0-option"
          >
            {option.hasIcon && (
              <div className="gender-icon">{renderIcon(option.iconType)}</div>
            )}
            <div className="option-text">
              <strong>{option.text}</strong>
            </div>
          </QuizOption>
        ))}
      </QuizOptions>
    </QuizContent>
  );
};

export default Step0;
